var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIconHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3618 3.12305H7.23978C4.92978 3.12305 3.05078 5.00905 3.05078 7.32505V14.264C3.05078 16.582 4.92978 18.467 7.23978 18.467H8.30878C8.81878 18.467 9.29678 18.666 9.65678 19.028L11.0788 20.453C11.4048 20.781 11.8398 20.962 12.3008 20.962C12.7618 20.962 13.1958 20.781 13.5228 20.454L14.9438 19.028C15.3058 18.666 15.7838 18.467 16.2938 18.467H17.3618C19.6718 18.467 21.5508 16.582 21.5508 14.264V7.32505C21.5508 5.00905 19.6718 3.12305 17.3618 3.12305Z",
    fill: "#FF6E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6744 18.4555C17.3733 16.604 15.6667 14.884 12.292 14.884C8.93064 14.884 7.22935 16.6045 6.92871 18.4556C7.03152 18.4632 7.13535 18.467 7.24007 18.467H8.30907C8.81907 18.467 9.29707 18.666 9.65707 19.028L11.079 20.453C11.405 20.781 11.84 20.962 12.301 20.962C12.762 20.962 13.196 20.781 13.523 20.454L14.944 19.028C15.306 18.666 15.784 18.467 16.294 18.467H17.362C17.4671 18.467 17.5713 18.4631 17.6744 18.4555Z",
    fill: "#FF6E42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8916 9.70197C8.8916 11.5818 10.4164 13.112 12.2917 13.112C14.1678 13.112 15.6926 11.5818 15.6926 9.70197C15.6926 7.82126 14.1678 6.29102 12.2917 6.29102C10.4164 6.29102 8.8916 7.82126 8.8916 9.70197Z",
    fill: "#FF6E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconHeader);
export default __webpack_public_path__ + "static/media/chat_icon_header.abd234a284f78c080818af7e5cc4e7c5.svg";
export { ForwardRef as ReactComponent };